import { render, staticRenderFns } from "./Shipments.vue?vue&type=template&id=cc5a7f1e&scoped=true&"
import script from "./Shipments.vue?vue&type=script&lang=js&"
export * from "./Shipments.vue?vue&type=script&lang=js&"
import style0 from "./Shipments.vue?vue&type=style&index=0&id=cc5a7f1e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc5a7f1e",
  null
  
)

export default component.exports